import { RequestService } from '../request-service';
import type {
  ConductRequest,
  ConductResponse,
} from '@wix/ambassador-conductor-server-v1-conduction/types';
import { Variant } from '@wix/ambassador-conductor-server-v1-conduction/types';
import type RpcModule from '@wix/ambassador-conductor-server-v1-conduction/rpc';
import type HttpModule from '@wix/ambassador-conductor-server-v1-conduction/http';

type conduct = {
  featureToggleId: string;
};

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class FeatureToggleService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-conductor-server-v1-conduction/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import(
      '@wix/ambassador-conductor-server-v1-conduction/http'
    );
  }

  public async conduct(payload: conduct): Promise<boolean> {
    try {
      const response = await this.request<ConductRequest, ConductResponse>({
        methodName: 'conduct',
        payload: { experimentId: payload.featureToggleId },
      });
      return response.variant === Variant.B;
    } catch {
      return false;
    }
  }
}
